<template>
  <header class="srm-header">
    <!-- 左侧：移动端菜单按钮 + 企业名称 + 实时时间 -->
    <div class="header-left">
      <!-- 移动端菜单按钮 -->
      <button 
        v-if="isMobile" 
        class="mobile-menu-btn" 
        @click="$emit('toggle-sidebar')"
      >
        <span class="menu-icon">☰</span>
      </button>
      
      <div class="brand">
        <span class="brand-icon">◈</span>
        <span class="brand-name">时代高科</span>
      </div>
      <div class="clock-box">
        <div class="clock-date">{{ currentDate }}</div>
        <div class="clock-time">{{ currentTime }}</div>
        <div class="clock-week">{{ currentWeek }}</div>
      </div>
    </div>

    <!-- 中间：系统标题 -->
    <div class="header-center">
      <div class="title-main">
        <span class="deco-line left"></span>
        <h1>供应商关系管理系统</h1>
        <span class="deco-line right"></span>
      </div>
      <div class="title-sub">SUPPLIER RELATIONSHIP MANAGEMENT</div>
    </div>

    <!-- 右侧：数据卡片 + 功能按钮 -->
    <div class="header-right">
      <div class="data-strip">
        <div class="data-item">
          <span class="data-label">本月采购额</span>
          <span class="data-value cyan">¥1.28亿</span>
        </div>
        <div class="data-item">
          <span class="data-label">活跃供应商</span>
          <span class="data-value cyan">328家</span>
        </div>
        <div class="data-item">
          <span class="data-label">待处理审批</span>
          <span class="data-value warn">12笔</span>
        </div>
      </div>

      <div class="action-group">
        <button class="srm-btn btn-glow-cyan" @click="handleRefresh">
          <span class="btn-icon">↻</span>
          <span class="btn-text">数据刷新</span>
        </button>
        <button class="srm-btn btn-glow-red" @click="handlePushCRM">
          <span class="btn-icon">⚠</span>
          <span class="btn-text">进入CRM</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SrmHeader',
  props: {
    sidebarCollapsed: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentDate: '',
      currentTime: '',
      currentWeek: '',
      timer: null
    }
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      const h = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const s = String(now.getSeconds()).padStart(2, '0')
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      
      this.currentDate = `${y}年${m}月${d}日`
      this.currentTime = `${h}:${min}:${s}`
      this.currentWeek = weeks[now.getDay()]
    },
    handlePushCRM() {
      this.$router.push('/CRM')
      // alert('全局预警中心：当前有 3 条高风险预警待处理')
    },
    handleRefresh() {
      alert('数据刷新成功：所有看板数据已同步至最新')
    }
  }
}
</script>

<style lang="scss" scoped>
.srm-header {
  height: 72px;
  background: #011039;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: relative;
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);
  flex-shrink: 0;
}

/* ==================== 左侧 ==================== */
.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 300px;
  flex-shrink: 0;
}

.mobile-menu-btn {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid rgba(0, 212, 255, 0.4);
  background: rgba(0, 212, 255, 0.08);
  color: #00d4ff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.15);
    box-shadow: 0 0 12px rgba(0, 212, 255, 0.3);
  }
}

.brand {
  display: flex;
  align-items: center;
  gap: 8px;
}

.brand-icon {
  font-size: 24px;
  color: #00d4ff;
  text-shadow: 0 0 12px rgba(0, 212, 255, 0.8);
  animation: pulse 2s infinite;
}

.brand-name {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
}

.clock-box {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}

.clock-date, .clock-week {
  font-size: 11px;
  color: #8c9bb3;
  letter-spacing: 1px;
}

.clock-time {
  font-size: 20px;
  font-weight: bold;
  color: #00d4ff;
  font-family: 'Courier New', monospace;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  letter-spacing: 2px;
}

/* ==================== 中间 ==================== */
.header-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.title-main {
  display: flex;
  align-items: center;
  gap: 20px;

  h1 {
    font-size: 26px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 6px;
    text-shadow: 0 0 30px rgba(0, 212, 255, 0.6);
    white-space: nowrap;
  }
}

.deco-line {
  width: 80px;
  height: 1px;
  background: rgba(0, 212, 255, 0.5);
  position: relative;

  &::after {
    content: '◆';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #00d4ff;
    font-size: 8px;
  }
}

.title-sub {
  font-size: 10px;
  color: rgba(0, 212, 255, 0.5);
  letter-spacing: 4px;
  margin-top: 4px;
}

/* ==================== 右侧 ==================== */
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  justify-content: flex-end;
}

.data-strip {
  display: flex;
  gap: 8px;
}

.data-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 10px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.15);
  border-radius: 6px;
  min-width: 72px;
}

.data-label {
  font-size: 10px;
  color: #8c9bb3;
  white-space: nowrap;
}

.data-value {
  font-size: 13px;
  font-weight: bold;
  margin-top: 2px;
  white-space: nowrap;

  &.cyan {
    color: #00d4ff;
  }

  &.warn {
    color: #ff6b6b;
    text-shadow: 0 0 8px rgba(255, 107, 107, 0.4);
  }
}

.action-group {
  display: flex;
  gap: 10px;
}

.srm-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  color: #fff;
  font-family: inherit;
  border: 1px solid transparent;
  overflow: hidden;
  transition: all 0.3s;
  background: transparent;
  white-space: nowrap;  /* 强制按钮内文字不换行 */

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.15;
    transition: opacity 0.3s;
    z-index: 0;
  }

  &:hover::before {
    opacity: 0.3;
  }

  &:hover {
    transform: translateY(-2px);
  }

  .btn-icon, .btn-text {
    position: relative;
    z-index: 1;
    white-space: nowrap;  /* 文字本身也不换行 */
  }
}

.btn-glow-red {
  border-color: rgba(255, 107, 107, 0.5);
  box-shadow: 0 0 15px rgba(255, 107, 107, 0.2), inset 0 0 10px rgba(255, 107, 107, 0.1);

  &::before {
    background: rgba(255, 107, 107, 0.3);
  }

  &:hover {
    box-shadow: 0 0 25px rgba(255, 107, 107, 0.4), inset 0 0 15px rgba(255, 107, 107, 0.2);
  }
}

.btn-glow-cyan {
  border-color: rgba(0, 212, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.2), inset 0 0 10px rgba(0, 212, 255, 0.1);

  &::before {
    background: rgba(0, 212, 255, 0.3);
  }

  &:hover {
    box-shadow: 0 0 25px rgba(0, 212, 255, 0.4), inset 0 0 15px rgba(0, 212, 255, 0.2);
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

/* ==================== 响应式 ==================== */
@media (max-width: 1400px) {
  .data-strip {
    display: none;
  }
}

@media (max-width: 1200px) {
  .header-right { gap: 12px; }
  .title-main h1 { font-size: 20px; letter-spacing: 3px; }
  .deco-line { width: 40px; }
  .brand-name { font-size: 14px; }
}

@media (max-width: 1024px) {
  .header-left { width: auto; }
  .clock-box { display: none; }
}

@media (max-width: 768px) {
  .srm-header { padding: 0 12px; height: 60px; }
  .title-main h1 { font-size: 16px; letter-spacing: 2px; }
  .btn-text { display: none; }
  .srm-btn { padding: 8px; }
}
</style>